import GridTable from '@nadavshaar/react-grid-table';
import 'dayjs/locale/pt-br';
import { inPlaceSort } from 'fast-sort';
import { isMobile } from 'react-device-detect';
import { BsPencilFill } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import CustomHeader from '../../../components/GridtableHeader/Header';
import {
  OSStatusOptionEnum,
  oSStatusOptions,
} from '../../ModalBudget/utils/constants';
import './BudgetScreen.scss';

const BudgetScreen = ({ data, user, onRemove, filter, setFilter }) => {
  let history = useHistory();
  inPlaceSort(data).by('code');
  data.reverse();

  return (
    <div className="bodyshop-container">
      <div
        style={{
          flexDirection: 'column',
        }}
        className="bodyshop-body default-table"
      >
        <CustomHeader isOS filter={filter} setFilter={setFilter} />
        <GridTable
          columns={
            isMobile
              ? columns(onRemove, user, history).filter(
                  (item) =>
                    item.id !== 4 &&
                    item.id !== 5 &&
                    item.id !== 7 &&
                    item.id !== 8
                )
              : columns(onRemove, user, history)
          }
          rows={data}
          showSearch={false}
          enableColumnsReorder={false}
          canReorder={false}
          isPaginated={false}
          showColumnVisibilityManager={false}
          showRowsInformation={false}
          texts={{
            noResults: 'Nenhum resultado foi encontrado',
            totalRows: 'Número de itens:',
            rows: 'Itens:',
            selected: 'Selecionado',
            rowsPerPage: 'Itens por página:',
            page: 'Página:',
            of: 'de',
            prev: 'Anterior',
            next: 'Próximo',
            columnVisibility: 'Colunas visíveis',
          }}
        />
      </div>
    </div>
  );
};

export default BudgetScreen;

const columns = (onRemove, user, history) => {
  return [
    {
      id: 1,
      field: 'id',
      label: isMobile ? 'Cód e Cliente' : 'Cód',
      width: '1fr',
      resizable: false,
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name mobile-clickable-name"
          onClick={() =>
            history.push(`/order-services/details/${data.id}`, data)
          }
        >
          {!isMobile ? data.code : ''}
          {isMobile ? <span>{data.code}</span> : ''}
          {isMobile ? <br /> : <></>}
          {isMobile ? <span>{data.client_name}</span> : ''}
        </div>
      ),
    },
    {
      id: 3,
      field: 'client_name',
      label: isMobile ? 'Veículo' : 'Cliente',
      resizable: false,
      width: '1fr',
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name mobile-clickable-name"
          onClick={() =>
            history.push(`/order-services/details/${data.id}`, data)
          }
        >
          {!isMobile ? data.client_name : ''}
          {isMobile ? <span>{data.Vehicle.model}</span> : ''}{' '}
          {isMobile ? <br /> : <></>}
          {isMobile ? <span>{data.Vehicle.plate}</span> : ''}
        </div>
      ),
    },
    {
      id: 4,
      field: 'vehicle_model',
      label: 'Carro',
      resizable: false,
      width: '1fr',
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name mobile-clickable-name"
          onClick={() =>
            history.push(`/order-services/details/${data.id}`, data)
          }
        >
          {data.Vehicle.model} <br />
        </div>
      ),
    },
    {
      id: 5,
      field: 'vehicle_name',
      label: 'Placa',
      resizable: false,
      width: '1fr',
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name mobile-clickable-name"
          onClick={() =>
            history.push(`/order-services/details/${data.id}`, data)
          }
        >
          {data.Vehicle.plate}
        </div>
      ),
    },
    {
      id: 6,
      field: 'status',
      label: 'Status',
      resizable: false,
      width: '1fr',
      cellRenderer: ({ data }) => {
        const selectedStatus = oSStatusOptions.find(
          (item) => item.id === data.status
        );
        let color, backgroundColor;
        switch (data.status) {
          case OSStatusOptionEnum.ABERTA:
            backgroundColor = '#6eb6ff';
            break;
          case OSStatusOptionEnum.FECHADA:
            backgroundColor = '#c95555';
            break;
          case OSStatusOptionEnum.QUITADA:
            backgroundColor = '#00A86B';
            break;
          default:
            color = '#fff';
            backgroundColor = '#6eb6ff';
        }

        const isSigned = data.client_authorization;
        const signatureBackgroundColor = isSigned ? '#00A86B' : '#FFA500';
        const signatureText = isSigned ? 'Assinado' : 'Não Assinado';

        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              padding: isMobile ? '6px 0' : '0',
            }}
          >
            <div
              className="clickable-name mobile-clickable-name color-name"
              style={{
                color: color,
                backgroundColor: backgroundColor,
                padding: isMobile ? '4px 8px' : undefined,
                fontSize: isMobile ? '11px' : undefined,
                minHeight: isMobile ? 'auto' : undefined,
              }}
              onClick={() =>
                history.push(`/order-services/details/${data.id}`, data)
              }
            >
              <text>{selectedStatus ? selectedStatus.value : 'Aberta'}</text>
            </div>
            {isMobile && (
              <div
                className="clickable-name mobile-clickable-name color-name"
                style={{
                  color: '#fff',
                  backgroundColor: signatureBackgroundColor,
                  fontSize: '10px',
                  padding: '3px 6px',
                  minHeight: 'auto',
                }}
                onClick={() =>
                  history.push(`/order-services/details/${data.id}`, data)
                }
              >
                <text>{signatureText}</text>
              </div>
            )}
          </div>
        );
      },
    },
    {
      id: 7,
      field: 'client_authorization',
      label: 'Status Assinatura',
      resizable: false,
      width: '1fr',
      cellRenderer: ({ data }) => {
        const isSigned = data.client_authorization;
        const backgroundColor = isSigned ? '#00A86B' : '#FFA500';
        const text = isSigned ? 'Assinado' : 'Não Assinado';

        return (
          <div>
            <div
              className="clickable-name mobile-clickable-name color-name"
              style={{
                color: '#fff',
                backgroundColor: backgroundColor,
              }}
              onClick={() =>
                history.push(`/order-services/details/${data.id}`, data)
              }
            >
              <text>{text}</text>
            </div>
          </div>
        );
      },
    },
    {
      id: 8,
      field: 'budget_actions',
      label: 'Ações',
      resizable: false,
      width: '70px',
      cellRenderer: ({ data }) => {
        if (!isMobile) {
          return (
            <ActionCell
              data={data}
              onRemove={onRemove}
              user={user}
              history={history}
            />
          );
        }
      },
    },
  ];
};

const ActionCell = ({ data, history }) => {
  return (
    <div className="field-actions">
      <BsPencilFill
        className="icon-action edit"
        onClick={() => history.push(`/order-services/details/${data.id}`, data)}
      />
    </div>
  );
};
